module.exports = __webpack_public_path__ + "static/media/python.cd433691.svg";